function loadDimensionsData(unitValue){
  if(unitValue == ''){
    return;
  }else{
    var params = JSON.parse(unitValue.replace(/=>/g,':'));
  }
  var dimensionstbody = $('#dimensions-tbody');
  var array = [''];
  if(params['data'] == undefined) {
      if (params['array'] != undefined) {
          array = params['array'];
      }else{
          return;
      }
  }
  for(var a = 0; a < array.length; a++) {
      var endStr = '';
      if (array[a] != '') {
          endStr = '-' + array[a];
      }
      var table = $('<table class="table table-bordered dimensions-table">');
      var head = params['head'+endStr];
      var tr = $('<tr class="table-tr thead">');
      for (var i = 0; i < head.length; i++) {
          tr.append($('<td>').html(head[i]));
      }
      table.append(tr);
      for (var i = 0; i < params['data'+endStr].length; i++) {
          d = params['data'+endStr][i];
          var tr = $('<tr class="table-tr tbody">');
          for (var j = 0; j < head.length; j++) {
              var v = d[head[j]];
              tr.append($('<td class="row-value" data-value="' + v + '">').html(v));
          }
          table.append(tr);
      }
      var title = params['title'+endStr];
      if(title != undefined && title != ''){
          dimensionstbody.append($('<div style="font-weight:bold">').html(title));
      }
      dimensionstbody.append(table);
  }

  $(".dimensions-table td").hover((function() {
          var t = $(this).prevAll().length + 1
              , e = $(this).closest("tr").prevAll().length + 1;
          t > 1 && $(this).closest("table").find("tr:lt(" + e + ") > td:nth-child(" + t + ")").addClass("col-highlight");
          e > 1 && $(this).closest("tr").find("td:lt(" + t + ")").addClass("col-highlight")
      }
  ), (function() {
          $(this).closest("table").find("tr > .col-highlight").removeClass("col-highlight")
      }
  ));

  $(document).delegate(".conver-dimensions label", 'click', function() {
      if ($(this).hasClass('active')){
          return false;
      }
      dimensions = $(this).text().toUpperCase();
      $('.conver-dimensions label.' + dimensions.toLowerCase()).addClass("active").siblings('label').removeClass('active');
      $('.dimensions-table .row-value').each(function() {
          var v = $(this).data('value') + "";
          var value = v;
          if(!v){
            value = '';
          }else if(dimensions == 'IN'){
            if (/^[\d\.]+(\-[\d\.]+)?$/.test(v)){
                var sv = [];
                v.split('-').forEach(function(val) {
                    val = ( val * 0.3937 ).toFixed(1) + ""
                    sv.push(val)
                });
                value = sv.join('-')
            }
          }
          $(this).text(value)
      })
  })
}